module.exports = __webpack_public_path__ + "static/media/Ellipse 3.82e4ced6.png";